import logoDark from "@/images/logo.png";
import slideOneImage1 from "@/images/custom/header-1.png";
import slideOneImage2 from "@/images/slider/slider-2.jpg";
import slideOneImage3 from "@/images/slider/slider-3.jpg";
import slideOneImage4 from "@/images/slider/slider-4.jpg";
import slideOneImage5 from "@/images/slider/slider-5.jpg";
import serviceImage1 from "@/images/services/service-1.jpg";
import serviceImage2 from "@/images/services/service-2.jpg";
import serviceImage3 from "@/images/services/service-3.jpg";
import funfactShape from "@/images/shape/about-shape.png";
import galleryOne1 from "@/images/gallery/gallery-1.jpg";
import galleryOne2 from "@/images/gallery/gallery-2.jpg";
import galleryOne3 from "@/images/gallery/gallery-3.jpg";
import galleryOne4 from "@/images/gallery/gallery-4.jpg";
import galleryOne5 from "@/images/gallery/gallery-5.jpg";
import galleryOne6 from "@/images/gallery/gallery-6.jpg";
import testimonial1 from "@/images/testimonial/testimonial-1.jpg";
import testimonial2 from "@/images/testimonial/testimonial-2.jpg";
import testimonial3 from "@/images/testimonial/testimonial-3.jpg";
import blog1 from "@/images/blog/blog-1.jpg";
import blog2 from "@/images/blog/blog-2.jpg";
import blog3 from "@/images/blog/blog-3.jpg";
import blog4 from "@/images/blog/blog-4.jpg";
import blog5 from "@/images/blog/blog-5.jpg";
import blog6 from "@/images/blog/blog-6.jpg";
import team1 from "@/images/team/team-1.jpg";
import team2 from "@/images/team/team-2.jpg";
import team3 from "@/images/team/team-3.jpg";
import team4 from "@/images/team/team-4.jpg";
import comment1 from "@/images/comment-1.jpg";
import comment2 from "@/images/comment-2.jpg";

import home1 from "@/images/home-button/01.png";
import home2 from "@/images/home-button/02.png";
import home3 from "@/images/home-button/03.png";
import home4 from "@/images/home-button/04.png";
import home5 from "@/images/home-button/05.png";

import service1custom from "@/images/services/pulizia.png";
import service2custom from "@/images/services/igenizzazione.png";
import service3custom from "@/images/services/disinfezione.png";
import service4custom from "@/images/services/derattizzazione.png";




export const Logo = {
    dark: logoDark
};

export const NavLinksData = [
    {
        name: "Home",
        url: "/"
    },
    {
        name: "Chi Siamo",
        url: "/about"
    },
    {
        name: "Servizi",
        url: "/service"
    },
    {
        name: "Contatti",
        url: "/contact"
    }
];

export const TopbarInfos = [
    {
        icon: "icon-placeholder",
        tagLine: "Dove siamo",
        text: "Via Caravaggio, 3 Trezzano sul Naviglio",
        url: "#"
    },
    {
        icon: "icon-phone-call",
        tagLine: "Chiamaci",
        text: "02 36706314",
        url: "tel:+390236706314"
    }
    // {
    //     icon: "icon-clock",
    //     tagLine: "Orari",
    //     text: "Lun-Ven: 08:00 - 18:00",
    //     url: "#"
    // }
];

export const SlideOneData = [
    {
        backgroundImage: slideOneImage1,
        title: "Curiamo la qualità del tuo ambiente di vita e di lavoro",
        text: "Impresa di pulizie",
        button: "Richiedi un preventivo",
        url: "/contact"
    }
    // {
    //     backgroundImage: slideOneImage2,
    //     title: "Installation Services & Repair",
    //     text: "Reliable Air Conditioning",
    //     button: "GET A FREE QUOTE",
    //     url: "/contact"
    // },
    // {
    //     backgroundImage: slideOneImage3,
    //     title: "Heating and Air Conditioning Specialist",
    //     text: "Choose the Best Company",
    //     button: "GET A FREE QUOTE",
    //     url: "/contact"
    // }
];

export const SlideTwoData = [
    {
        backgroundImage: slideOneImage4,
        title: "Heating and Air Conditioning Specialis",
        button: "GET A FREE QUOTE",
        url: "/contact"
    },
    {
        backgroundImage: slideOneImage5,
        title: "Keep your family happy this winter, and warm.",
        button: "GET A FREE QUOTE",
        url: "/contact"
    },
    {
        backgroundImage: slideOneImage4,
        title: "Heating and Air Conditioning Specialist",
        button: "GET A FREE QUOTE",
        url: "/contact"
    }
];

export const FeatureOneData = [
    {
        icon: home1,
        title: "PREVENTIVO GRATUITO"
    },
    {
        icon: home2,
        title: "SERVIZI PERSONALIZZATI"
    },
    {
        icon: home3,
        title: "20 ANNI DI ESPERIENZA"
    },
    {
        icon: home4,
        title: "ECOLOGIA E SOSTENIBILITà"
    },
    {
        icon: home5,
        title: "PRIVATI, AZIENDE E UFFICI"
    }
];

export const AboutOneData = {
    title: "Heating and air conditioning repair and installation company",
    tagLine: "Welcome to loazzne",
    content:
        "There are many variations of passages of lorem ipsum available, but the majorify have suffered alteration in some form by injected humour, or randmised words which don't look even slightly believable.",
    button: {
        url: "/about",
        label: "LEARN MORE"
    }
};

export const ServiceOneData = {
    title: "I nostri Servizi",
    posts: [
        {
            image: service1custom,
            icon: "icon-snow",
            title: "Pulizia e Igienizzazione",
            text: "Servizi di pulizie generali per privati, aziende e uffici.\n",
            button: {
                label: "LEARN MORE",
                url: "/service-details"
            }
        },
        {
            image: service2custom,
            icon: "icon-fire",
            title: "Sanificazione",
            text: "Interventi mirati a eliminare alla base qualsiasi batterio e agente contaminante.",
            button: {
                label: "LEARN MORE",
                url: "/service-details"
            }
        },
        {
            image: service3custom,
            icon: "icon-ac",
            title: "Disinfestazione",
            text: "Eliminazione di insetti, parassiti o di altri animali nocivi.",
            button: {
                label: "LEARN MORE",
                url: "/service-details"
            }
        },
        {
            image: service4custom,
            icon: "icon-ac",
            title: "Derattizzazione",
            text: "Disinfestazione dai ratti in ambienti aperti e chiusi\n",
            button: {
                label: "LEARN MORE",
                url: "/service-details"
            }
        }
    ]
};

export const CallToActionOneData = {
    title: "RICHIEDI SUBITO UN PREVENTIVO",
    button: {
        url: "/contact",
        label: "Contattaci"
    }
};

export const CallToActionTwoData = {
    left: {
        text: "Air Conditioning Services",
        title: "Cool it down"
    },
    right: {
        text: "Heating Services",
        title: "Heat it up"
    }
};

export const FunfactOneData = {
    shapeImage: funfactShape,
    title: "Numbers Speakers.",
    posts: [
        {
            count: 5600,
            text: "Metri quadri"
        },
        {
            count: 80,
            text: "Operatori"
        },
        {
            count: 110,
            text: "Clienti"
        }
    ]
};

export const GalleryOneData = [
    {
        title: "Maintenance and Repair",
        image: galleryOne1,
        url: "#"
    },
    {
        title: "Maintenance and Repair",
        image: galleryOne2,
        url: "#"
    },
    {
        title: "Maintenance and Repair",
        image: galleryOne3,
        url: "#"
    },
    {
        title: "Maintenance and Repair",
        image: galleryOne4,
        url: "#"
    },
    {
        title: "Maintenance and Repair",
        image: galleryOne5,
        url: "#"
    },
    {
        title: "Maintenance and Repair",
        image: galleryOne6,
        url: "#"
    }
];

export const TestimonialOneData = {
    title: "Testimonials",
    posts: [
        {
            image: testimonial1,
            content:
                "This is due to their excellent service, competitive pricing and customer support . It's throughly refresing to get such a personal touch.",
            name: "Della Barnett",
            designation: "CEO"
        },
        {
            image: testimonial2,
            content:
                "This is due to their excellent service, competitive pricing and customer support . It's throughly refresing to get such a personal touch.",
            name: "Max Dunn",
            designation: "Developer"
        },
        {
            image: testimonial3,
            content:
                "This is due to their excellent service, competitive pricing and customer support . It's throughly refresing to get such a personal touch.",
            name: "Alberta Potter",
            designation: "Director"
        },
        {
            image: testimonial1,
            content:
                "This is due to their excellent service, competitive pricing and customer support . It's throughly refresing to get such a personal touch.",
            name: "Della Barnett",
            designation: "CEO"
        },
        {
            image: testimonial2,
            content:
                "This is due to their excellent service, competitive pricing and customer support . It's throughly refresing to get such a personal touch.",
            name: "Max Dunn",
            designation: "Developer"
        },
        {
            image: testimonial3,
            content:
                "This is due to their excellent service, competitive pricing and customer support . It's throughly refresing to get such a personal touch.",
            name: "Alberta Potter",
            designation: "Director"
        }
    ]
};

export const FooterBottomData = {
    social: [
        {
            icon: "fa fa-facebook-f",
            url: "https://www.facebook.com/rougemultiservice"
        },
        {
            icon: "fa fa-instagram",
            url: "https://www.instagram.com/rougemultiservice"
        },

        {
            icon: "fa fa-linkedin",
            url: "https://www.linkedin.com/company/rougemultiservice/"
        }
    ]
};

export const FooterInfo = [
    {
        icon: "icon-placeholder",
        tagLine: "Dove siamo",
        text: "Via Caravaggio, 3 Trezzano sul Naviglio",
        url: "#"
    },
    {
        icon: "icon-phone-call",
        tagLine: "Chiamaci",
        text: "02 36706314",
        url: "tel:+390236706314"
    },
    // {
    //     icon: "icon-clock",
    //     tagLine: "Orari",
    //     text: "Lun-Ven: 08:00 - 18:00",
    //     url: "#"
    // }
];

export const FooterWidgets = {
    about: {
        title: "Rouge Multiservice",
        text: "Rouge Multiservice nasce nel 2021 dopo un’esperienza lavorativa ventennale nel campo dei servizi di pulizia: un'azienda giovane, al passo coi tempi e con le nuove tecnologie formata da professionisti di provata capacità.",
        tagLine: "Richiedi un preventivo",
        phone: "+39 02 36706314"
    },
    linkOne: {
        title: "Quick Links",
        menu: [
            {
                lable: "Chi Siamo",
                url: "/about"
            },
            {
                lable: "Servizi",
                url: "/service"
            },
            {
                lable: "Contattaci",
                url: "/contact"
            }

        ]
    },
    linkTwo: {
        menu: [
            {
                lable: "Privacy Policy",
                url: "#"
            },
            {
                lable: "Terms & Conditions",
                url: "#"
            }
        ]
    }
};

export const BlogOneData = {
    title: "Our latest news",
    posts: [
        {
            image: blog1,
            date: "07 Nov",
            author: "admin",
            commentCount: 3,
            title: "How does a ductless heat pump work?",
            url: "/blog-details",
            text: "There are many variations passages of lorem ipsum available but the majority have suffered alteration."
        },
        {
            image: blog2,
            date: "07 Nov",
            author: "admin",
            commentCount: 3,
            title: "Simple hack to improve A/C efficiency",
            url: "/blog-details",
            text: "There are many variations passages of lorem ipsum available but the majority have suffered alteration."
        },
        {
            image: blog3,
            date: "07 Nov",
            author: "admin",
            commentCount: 3,
            title: "Preparing your home before vacation",
            url: "/blog-details",
            text: "There are many variations passages of lorem ipsum available but the majority have suffered alteration."
        }
    ]
};

export const BlogTwoData = {
    posts: [
        {
            image: blog1,
            date: "07 Nov",
            author: "admin",
            commentCount: 3,
            title: "How does a ductless heat pump work?",
            url: "/blog-details",
            text: "There are many variations passages of lorem ipsum available but the majority have suffered alteration."
        },
        {
            image: blog2,
            date: "07 Nov",
            author: "admin",
            commentCount: 3,
            title: "Simple hack to improve A/C efficiency",
            url: "/blog-details",
            text: "There are many variations passages of lorem ipsum available but the majority have suffered alteration."
        },
        {
            image: blog3,
            date: "07 Nov",
            author: "admin",
            commentCount: 3,
            title: "Preparing your home before vacation",
            url: "/blog-details",
            text: "There are many variations passages of lorem ipsum available but the majority have suffered alteration."
        },
        {
            image: blog4,
            date: "07 Nov",
            author: "admin",
            commentCount: 3,
            title: "Heating and cooling safety issues",
            url: "/blog-details",
            text: "There are many variations passages of lorem ipsum available but the majority have suffered alteration."
        },
        {
            image: blog5,
            date: "07 Nov",
            author: "admin",
            commentCount: 3,
            title: "Don’t neglect your outdoor unit",
            url: "/blog-details",
            text: "There are many variations passages of lorem ipsum available but the majority have suffered alteration."
        },
        {
            image: blog6,
            date: "07 Nov",
            author: "admin",
            commentCount: 3,
            title: "Have your system professionally inspected",
            url: "/blog-details",
            text: "There are many variations passages of lorem ipsum available but the majority have suffered alteration."
        }
    ]
};

export const VideoOneData = {
    title: "Watch how we work",
    id: "8DP4NgupAhI"
};

export const AboutTwoData = {
    caption: " 20 <span>years experience</span> ",
    blockTitle: {
        title:
            "We are trusted source of ac and heating maintenance repairs company",
        tagline: "Why choose us"
    },
    lists: [
        {
            text: " Unmatched performance, satisfaction service guarantees"
        },
        {
            text: " Home protection through our shoe covers and mats"
        },
        {
            text: " Upfront, flat rate pricing—no overtime charges"
        },
        {
            text: " 24 / 7 availability for all emergency services"
        },
        {
            text: " Fixed right promise—done right or it’s free"
        },
        {
            text: " Clear communication and updates on service arrival"
        }
    ],
    offer: {
        tagline: "10% off",
        text: "on our all services for senior citizens."
    }
};

export const TeamOneData = {
    title: "Meet The Team",
    posts: [
        {
            image: team1,
            name: "Effie Green",
            designation: "Manager",
            social: [
                {
                    icon: "fa-facebook",
                    url: "#"
                },
                {
                    icon: "fa-twitter",
                    url: "#"
                },
                {
                    icon: "fa-youtube-play",
                    url: "#"
                }
            ]
        },
        {
            image: team2,
            name: "Catherine Lane",
            designation: "Worker",
            social: [
                {
                    icon: "fa-facebook",
                    url: "#"
                },
                {
                    icon: "fa-twitter",
                    url: "#"
                },
                {
                    icon: "fa-youtube-play",
                    url: "#"
                }
            ]
        },
        {
            image: team3,
            name: "Augusta Wells",
            designation: "Developer",
            social: [
                {
                    icon: "fa-facebook",
                    url: "#"
                },
                {
                    icon: "fa-twitter",
                    url: "#"
                },
                {
                    icon: "fa-youtube-play",
                    url: "#"
                }
            ]
        },
        {
            image: team4,
            name: "Kyle Fuller",
            designation: "Founder",
            social: [
                {
                    icon: "fa-facebook",
                    url: "#"
                },
                {
                    icon: "fa-twitter",
                    url: "#"
                },
                {
                    icon: "fa-youtube-play",
                    url: "#"
                }
            ]
        }
    ]
};

export const AboutThreeData = {
    blockTitle: {
        tagline: "Our success story",
        title: "Experience quality air conditioning service in broklyn new york"
    },
    summery:
        "There are many variations of passages of lorem ipsum available, but the majorify have suffered alteration in some form by injected humour, or randmised words which don't look even slightly believable.",
    button: {
        lable: "LEARN MORE",
        url: "/about"
    },
    box: [
        {
            icon: "icon-maintenance",
            title: "We make as cool again"
        },
        {
            icon: "icon-big-ac",
            title: "Keep your business cool"
        }
    ]
};

export const AboutFourData = {
    blockTitle: {
        title: "Per ambienti, immobili, sedi di istituzioni pubbliche o private, privati.",
        text1:
            "Tincidunt elit magnis nulla facilisis sagittis is maecenas. Sapien nunced amet ultrices, dolores sit ipsum velit purus aliquet, massa fringilla leo orci.",
        text2:
            "Lorem ipsum dolors sit amet elit magnis amet ultrices purusrfed aliquet. There are many varia-tions of passages of available but the majarity have suffered."
    }
};

export const BenefitOneData = {
    title: "Our benefits",
    posts: [
        {
            icon: "icon-big_clock",
            title: "Emergency Service",
            text: "There are many passages of lorem ipsum available but the majority have alteration."
        },
        {
            icon: "icon-wallet",
            title: "No Upfront Payment",
            text: "There are many passages of lorem ipsum available but the majority have alteration."
        },
        {
            icon: "icon-diploma",
            title: "Satisfaction Guarantee",
            text: "There are many passages of lorem ipsum available but the majority have alteration."
        },
        {
            icon: "icon-mechanic",
            title: "8 Years Experience",
            text: "There are many passages of lorem ipsum available but the majority have alteration."
        }
    ]
};

export const ServiceSidebarListData = [
    {
        icon: "icon-snow",
        title: "Cooling Services",
        list: [
            {
                label: "Air Conditioner Maintenance",
                url: "#"
            },
            {
                label: "Air Conditioner Repair",
                url: "#"
            },
            {
                label: "Air Conditioner Replacement",
                url: "#"
            },
            {
                label: "Ductless Split AC Systems",
                url: "#"
            },
            {
                label: "Duct Cleaning & Installation",
                url: "#"
            }
        ]
    },
    {
        icon: "icon-fire",
        title: "Heating Services",
        list: [
            {
                label: "Air Conditioner Maintenance",
                url: "#"
            },
            {
                label: "Air Conditioner Repair",
                url: "#"
            },
            {
                label: "Air Conditioner Replacement",
                url: "#"
            },
            {
                label: "Ductless Split AC Systems",
                url: "#"
            },
            {
                label: "Duct Cleaning & Installation",
                url: "#"
            }
        ]
    }
];

export const ServiceSidebarOtherData = [
    {
        icon: "icon-ac",
        title: "Other Services",
        content: {
            icon: "icon-support",
            title: "<span>Contact with us </span>666 888 000"
        }
    },
    {
        icon: "icon-building",
        title: "Commercial Services",
        content: {
            icon: "icon-building",
            title: "<span>Contact with us </span>666 888 000"
        }
    }
];

export const CommentPostData = [
    {
        name: "David Martin",
        image: comment1,
        time: "10 Nov, 2018 - 4:00 pm",
        text: "Lorem Ipsum is simply dummy text of the rinting and typesetting been the industry standard dummy text ever sincer condimentum purus. In non ex at ligula fringilla lobortis et aliquet."
    },
    {
        name: "Jessica Brown",
        image: comment2,
        time: "10 Nov, 2018 - 4:00 pm",
        text: "Lorem Ipsum is simply dummy text of the rinting and typesetting been the industry standard dummy text ever sincer condimentum purus. In non ex at ligula fringilla lobortis et aliquet."
    }
];
